import { render, staticRenderFns } from "./commonChat.vue?vue&type=template&id=0ead6d26"
import script from "./commonChat.vue?vue&type=script&lang=js"
export * from "./commonChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports